Postlogin = (function (postlogin) {
    postlogin.AssessmentOverallResults = {};
    const self = postlogin.AssessmentOverallResults;
    const initGoogleChart = function () {
        // Load the Visualization API and the corechart package.
        google.charts.load('current', { packages: ['corechart'] });

        // Set a callback to run when the Google Visualization API is loaded.
        google.charts.setOnLoadCallback(drawChart);

        // Callback that creates and populates a data table,
        // instantiates the pie chart, passes in the data and
        // draws it.
        function drawChart() {
            let jsonData;

            $.ajax({
                url: $('#assessment-results-chart').attr('data-json-url'),
                data: {
                    license_id: $('#license-filter').val(),
                },
                dataType: 'json',
                method: 'GET',
                async: false,
                success(json) {
                    jsonData = json.data;
                },
            });

            // Create our data table out of JSON data loaded from server.
            const data = new google.visualization.DataTable(jsonData);

            const options = {
                pieHole: 0.1,
                backgroundColor: 'transparent',
                is3D: false,
                chartArea: {
                    left: '5%',
                    top: '10%',
                    right: '5%',
                    bottom: '5%',
                    width: '95%',
                    height: '95%',
                },
            };

            const view = new google.visualization.DataView(data);
            view.setColumns([0, 2]);

            const chartDiv = document.getElementById('assessment-results-chart');
            const chart = new google.visualization.PieChart(chartDiv);

            // Wait for the chart to finish drawing before calling the getImageURI() method.
            google.visualization.events.addListener(chart, 'ready', () => {
                $('#export-png-link').attr('href', chart.getImageURI());
                $('#overall-results-chart-export').fadeIn();
            });

            chart.draw(view, options);

            const selectHandler = function () {
                window.location = data.getValue(chart.getSelection()[0].row, 1);
            };

            // Add our selection handler.
            google.visualization.events.addListener(chart, 'select', selectHandler);
        }

        $(window).on('resize', _.debounce(drawChart, 250));
    };

    self.init = function () {
        setTimeout(() => {
            initGoogleChart();
        }, 1);
    };

    return postlogin;
}(Postlogin || {}));
